import React from 'react';
import { useContext, useState } from 'react';
import NumberFormat from 'react-number-format';
import config from './../../../services/config.json';
import SimpleContext from './../../context/SimpleContext';
import { Button, Modal } from 'react-bootstrap';
import Counter3 from './../counter/Counter3';
import './FreshDialog.css';

const FreshProducts = ({
    image, 
    name, 
    id,
}) => {

    const context = useContext(SimpleContext);

    const [modalShow, setModalShow] = useState(false); 

    let FreshPro = [...context.products];
    const FreshProducts = FreshPro.filter(pr => pr.FreshStatus === 1 && pr.LastLevID === id);


    return (  
        <>
        <div className="imageAndTitleFresh">
            <div className="freshimagePlace">
                <img src={`${config.ApyCategoryPictures}/${image}.jpg`} className="freshImg" alt=""/>
            </div>
            <div className="freshTitlePlace">
                <p>
                    {name}
                </p>
            </div>
        </div>

        <div className="freshTablePlace">
            <table className="table" onClick={() => setModalShow(true)}>
                {
                    FreshProducts.map((fr,i) => (
                        <tr key={i} className="tableRow">
                            <td className="td1">{fr.name}</td>
                            <td className="td2"><NumberFormat value={fr.price} displayType={'text'} thousandSeparator={true} /> ريال</td>
                        </tr>
                    ))
                }
            </table>
        </div>

        <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            centered

            >
                <Modal.Header style={{padding:"2%"}}>
                        <Modal.Title id="contained-modal-title-vcenter"
                        className="HeaderDialog"
                        >
                            <img src={`${config.ApyCategoryPictures}/${image}.jpg`} className="DialogImg" alt="FreshPic"/>
                            <p>{name}</p>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{padding:"2%", height:"400px", overflowY:"scroll"}}>
                {
                    FreshProducts.map((fr,i) => (
                        <div className="DialogProducts" key={i}>
                            <div className="titleDialogProducts">
                                <p>{fr.name}</p>
                                <p><NumberFormat value={fr.price} displayType={'text'} thousandSeparator={true} /> ريال</p>
                            </div>
                            <div className="counterPlace">
                                <Counter3 min={fr.minimum} max={fr.maximum} unit={fr.unit} numUnit={fr.number_in_unit} price={fr.price} slug={fr.slug} name={fr.name} stock={fr.stock} numSale={fr.number_in_sale} goodsRef={fr.goods_ref} uniqueid={fr.unique_id}/>
                            </div>
                        </div>
                    ))
                }
                </Modal.Body>
                    <Modal.Footer style={{padding:"0"}}>
                        <Button onClick={() => setModalShow(false)} className="DialogButton">تایید</Button>
                    </Modal.Footer>
            </Modal>
    </>
    );
}
 
export default FreshProducts;